import defaultErrorHandler from "actions/global/default-error-handler";
import settings from "utils/settings";

import { requestCommonFilters, requestCommonSearch } from "../../common/requests";
import {
  SCOOTER_HISTORY_ERROR,
  SCOOTER_HISTORY_LOADING,

  SCOOTER_HISTORY_FILTERS,
  SCOOTER_HISTORY_LIST
} from "./constants";

const scooterUrl = `${settings.scooterUrl}api/`;
const ENDPOINT = "admin/scooter/history";

export const setLoading = (status) => ({
  type: SCOOTER_HISTORY_LOADING,
  payload: status
});

export const getFilters = () => dispatch => {
  requestCommonFilters(ENDPOINT, scooterUrl)
    .then((response) => {
      dispatch({
        type: SCOOTER_HISTORY_FILTERS,
        payload: response.data
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, SCOOTER_HISTORY_ERROR));
    });
};

export const getList = (page = 0, size = 20, sort = "id,asc", filters = []) => dispatch => {
  dispatch(setLoading(true));
  requestCommonSearch(ENDPOINT, page, size, sort, filters, scooterUrl)
    .then((response) => {
      dispatch({
        type: SCOOTER_HISTORY_LIST,
        payload: response
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, SCOOTER_HISTORY_ERROR));
    });
};



// WEBPACK FOOTER //
// ./src/actions/scooter/history/actions.js